module.exports = __webpack_public_path__ + "static/media/blank6.5.bc009fa4.ogg";